module.exports = __webpack_public_path__ + "static/img/rank_92.8b7695b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_92.png
// module id = oPom
// module chunks = 1